module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isDeleted) ? _c('div', {
    key: _vm.myOrder.id,
    staticClass: "list-item",
    attrs: {
      "order-id": _vm.myOrder.id
    }
  }, [(_vm.myOrder.activity_id == 41) ? _c('div', {
    staticClass: "order-type-tag-wrap"
  }, [_vm._v("\n    >\n    "), _c('div', {
    staticClass: "order-type-tag"
  }, [_vm._v("\n      咨询预沟通\n    ")])]) : _vm._e(), _vm._v(" "), _c('v-touch', {
    staticClass: "item-top",
    on: {
      "tap": function($event) {
        _vm.localLinkToDetail(_vm.myOrder)
      }
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.myOrder.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-details"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.myOrder.name) + "\n        ")]), _vm._v(" "), (_vm.role === 'teacher' && _vm.order.is_new === 1) ? _c('span', {
    staticClass: "new-icon new"
  }, [_vm._v("\n          new\n        ")]) : _vm._e(), _vm._v(" "), (_vm.order.is_offline === 1) ? _c('span', {
    staticClass: "new-icon siren"
  }, [_vm._v("\n          私人\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.showFirstConsultRedDot) ? _c('i', {
    staticClass: "icon-redDot"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "type"
  }, [_c('i', {
    class: ['yxlicon', _vm.getIconCls(_vm.myOrder.waytype)]
  }), _vm._v(" "), _c('span', {
    staticClass: "type-name"
  }, [_vm._v(_vm._s(_vm.myOrder.waytype) + _vm._s((" x " + (_vm.myOrder.zx_num))))])]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("￥ " + _vm._s(parseFloat(_vm.myOrder.fee)))])]), _vm._v(" "), _c('div', {
    class: [
      'status',
      'status-' + _vm.orderItemStatus[_vm.myOrder.process_status].class
    ],
    domProps: {
      "innerHTML": _vm._s(_vm.orderItemStatus[_vm.myOrder.process_status].text)
    }
  })]), _vm._v(" "), [_c('div', {
    staticClass: "opt-bar"
  }, [_c('div', {
    staticClass: "created-time"
  }, [_vm._v(_vm._s(_vm.myOrder.created))]), _vm._v(" "), (
    _vm.myOrder.history === 1 &&
    (_vm.myOrder.process_status === 'waitPay' ||
      _vm.myOrder.process_status === 'waitAccept')
  ) ? _c('v-touch', {
    staticClass: "opt-btn",
    attrs: {
      "tag": "div"
    },
    on: {
      "tap": function($event) {
        _vm.linkToOrderHistory(_vm.myOrder.user_id)
      }
    }
  }, [_vm._v("咨询记录\n      ")]) : _vm._e(), _vm._v(" "), (_vm.myOrder.process_status === 'cancel') ? _c('v-touch', {
    staticClass: "opt-btn",
    on: {
      "tap": function($event) {
        _vm._deleteOrder()
      }
    }
  }, [_vm._v("删除订单\n      ")]) : _vm._e(), _vm._v(" "), (
    [
      'refund',
      'waitRefund',
      'cancel',
      'waitConsult',
      'complete',
      'waitRate',
      'waitComplete'
    ].indexOf(_vm.myOrder.process_status) !== -1
  ) ? _c('v-touch', {
    staticClass: "opt-btn",
    on: {
      "tap": function($event) {
        _vm.localLinkToDetail(_vm.myOrder)
      }
    }
  }, [_vm._v("查看详情\n      ")]) : _vm._e(), _vm._v(" "), (_vm.myOrder.process_status === 'waitPay') ? _c('v-touch', {
    class: {
      'opt-btn': true,
      disabled: _vm.isCanNotEditPrice
    },
    attrs: {
      "tag": "div"
    },
    on: {
      "tap": _vm.changePrice
    }
  }, [_vm._v("\n        " + _vm._s(_vm.isCanNotEditPrice ? '不可改价' : '修改价格') + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.myOrder.process_status === 'waitAccept') ? [_c('v-touch', {
    staticClass: "opt-btn accept-btn",
    attrs: {
      "tag": "button"
    },
    on: {
      "tap": _vm._acceptReservation
    }
  }, [_vm._v("受理咨询\n        ")])] : _vm._e(), _vm._v(" "), (_vm.myOrder.process_status === 'waitConsult') ? void 0 : _vm._e(), _vm._v(" "), (_vm.myOrder.process_status === 'waitComplete') ? [_c('v-touch', {
    staticClass: "opt-btn remind-btn",
    attrs: {
      "tag": "span"
    },
    on: {
      "tap": function($event) {
        _vm.remind(_vm.role === 'user', _vm.myOrder.id)
      }
    }
  }, [_vm._v("提醒确认\n        ")])] : _vm._e(), _vm._v(" "), (_vm.order.process_status === 'waitRate') ? void 0 : _vm._e(), _vm._v(" "), (_vm.order.process_status === 'waitRefund') ? void 0 : _vm._e(), _vm._v(" "), (_vm.order.process_status === 'refund') ? void 0 : _vm._e(), _vm._v(" "), _c('v-touch')], 2)]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d550c232!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/consultation/consultationOrderItem.vue
// module id = 2615
// module chunks = 115